// extracted by mini-css-extract-plugin
module.exports = {"globalLoader":"Loader_globalLoader__2OK3N","loader":"Loader_loader__2hZcM","buttonLoader":"Loader_buttonLoader__3UvjM"};